//global
import React, { useState } from 'react';
import { RichText, withDatasourceCheck, Text } from '@sitecore-jss/sitecore-jss-nextjs';
//local
import { ComponentProps } from 'lib/component-props';
import { PSP } from 'models/PetSuppliesPlus.Model';
import ButtonHelper from 'src/helpers/commonComponents/Button';
import ModalWrapper from 'src/helpers/commonComponents/ModalWrapper';
import deleteAccount from 'tailwindVariants/components/deleteAccountTailwindVariant';
import ImageHelper from 'src/helpers/commonComponents/ImageHelper';
import { useRouter } from 'next/router';
import { useOcDispatch, useOcSelector } from 'src/redux/ocStore';
import { apiRequest } from 'src/utils/apiWrapper';
import { nextMobileEndpoints } from 'src/utils/nextApiConfig';
import { ErrorCodes } from 'src/helpers/Constants';
import logout from 'src/redux/ocAuth/logout';

type DeleteAccountProps = ComponentProps &
  PSP.Sitecore.templates.PetSuppliesPlus.Accounts.DeleteAccount.Fields.DeleteAccount;

const DeleteAccount: React.FC<DeleteAccountProps> = ({ fields }) => {
  //Tailwind Variant
  const {
    deleteWrapper,
    deleteHeading,
    deleteDescription,
    deleteIconAndCTAWrapper,
    icon,
    deleteCTA,
    popUpWrapper,
    popUpWidth,
    popUpTitle,
    popUpDescription,
    popUpCTAWrapper,
    popUpCTAs,
    gotItCTA,
    deleteInfo,
  } = deleteAccount({
    size: { initial: 'mobile', md: 'desktop' },
  });

  //states
  const [showPreventionPopUp, setShowPreventionPopUp] = useState(false);
  const [showConfirmationPopUp, setShowConfirmationPopUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const dispatch = useOcDispatch();
  const userDetails = useOcSelector((state) => state?.ocUser?.user);

  //to perform delete account action
  const handleDeleteAccount = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest(nextMobileEndpoints.deleteUserAccount, {
        method: 'POST',
        data: { Email: userDetails?.Email },
      });
      setIsLoading(false);
      if (res == ErrorCodes.Success) {
        setShowPreventionPopUp(false);
        setShowConfirmationPopUp(true);
      } else {
        throw Error('Something went wrong!');
      }
    } catch (error) {
      console.error('@@Error :', error);
    }
  };

  const handleConfirmationCTA = async () => {
    setShowConfirmationPopUp(false);
    await dispatch(logout());
    router.push('/');
  };

  return (
    <div data-component="Component/DeleteAccount/DeleteAccount">
      {/**Error Prevention Pop-Up */}
      <ModalWrapper
        showCloseButtonInModalHeader={false}
        closeModalOnOverlayClick={true}
        showModal={showPreventionPopUp}
        onCloseClick={() => {
          setShowPreventionPopUp(false);
        }}
        additionalClassForPopUpModal=""
        popupWidth={popUpWidth()}
        customPopup
      >
        <div className={popUpWrapper({ className: 'errorPreventionPopUp' })}>
          <RichText field={fields?.preventionTitle} tag="p" className={popUpTitle()} />
          <RichText field={fields?.preventionDescription} className={popUpDescription()} tag="p" />
          <div className={popUpCTAWrapper()}>
            <ButtonHelper
              isLinkField={false}
              size="default"
              variant={`${isLoading ? 'disabled' : 'primary'}`}
              isDisabled={isLoading}
              field={fields?.preventionConfirmationText}
              onClickHandler={handleDeleteAccount}
              className={popUpCTAs()}
            />
            <ButtonHelper
              isLinkField={false}
              size="default"
              variant={`${isLoading ? 'disabled' : 'secondary'}`}
              isDisabled={isLoading}
              field={fields?.preventionCancelText}
              onClickHandler={() => {
                setShowPreventionPopUp(false);
              }}
              className={popUpCTAs()}
            />
          </div>
        </div>
      </ModalWrapper>

      {/**Confirmation Pop-Up */}
      <ModalWrapper
        showCloseButtonInModalHeader={false}
        closeModalOnOverlayClick={true}
        showModal={showConfirmationPopUp}
        onCloseClick={() => {
          setShowConfirmationPopUp(false);
        }}
        additionalClassForPopUpModal=""
        popupWidth={popUpWidth()}
        customPopup
      >
        <div className={popUpWrapper({ className: 'confirmationPopUp' })}>
          <RichText field={fields?.preventionTitle} className={popUpTitle()} tag="p" />
          <RichText field={fields?.preventionDescription} className={popUpDescription()} tag="p" />
          <div className={popUpCTAWrapper()}>
            <ButtonHelper
              isLinkField={false}
              size="default"
              variant="primary"
              field={fields?.confirmationText}
              onClickHandler={handleConfirmationCTA}
              className={gotItCTA()}
            />
          </div>
        </div>
      </ModalWrapper>
      <div className={deleteWrapper()}>
        <div className={deleteInfo()}>
          <RichText field={fields?.heading} className={deleteHeading()} />
          <RichText field={fields?.description} className={deleteDescription()} />
        </div>
        <div className={deleteIconAndCTAWrapper()}>
          <ImageHelper field={fields?.icon} className={icon()} />
          <Text
            tag="span"
            field={fields?.deleteAccountCTA}
            className={deleteCTA()}
            onClick={() => {
              setShowPreventionPopUp(true);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default withDatasourceCheck()<DeleteAccountProps>(DeleteAccount);
